import { render } from "./RemoveElementsTab.vue?vue&type=template&id=253a1afc&scoped=true"
import script from "./RemoveElementsTab.vue?vue&type=script&lang=js"
export * from "./RemoveElementsTab.vue?vue&type=script&lang=js"

import "./RemoveElementsTab.vue?vue&type=style&index=0&id=253a1afc&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253a1afc"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem});
